module.exports = __webpack_public_path__ + "img/move.8bfeb3f9.svg";